import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";

import CountryWithFlag from "@app/component/country/CountryWithFlag";

const CountryCellRenderer: React.FC<ICellRendererParams> = ({ node, value }) => {
  // length !== 2 can happen when Address field is PHI Enabled and masked, then we get a bunch
  // of dots instead of a real country code value
  if (!value || !value.length || value.length !== 2) {
    // Wrapping into fragment because this component can't return a plain string.
    return <>{node.data.country}</>;
  }
  const countryCode = value as CountryCode;

  return <CountryWithFlag countryCode={countryCode} />;
};

export default CountryCellRenderer;
